__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/984f726/packs/";